export default "__VITE_ASSET__DPdIsSdL__"